
import React from 'react';
import Modal from "react-modal";
import "./SuccessModal.css";
import Lottie from "lottie-react";
import Complete from "../../../assets/lottie/Complete.json";
import Error from "../../../assets/lottie/Error.json";

const LoggedOut = (props) => {
    const {  LoggedIn, setLoggedIn } = props;

 

const closeModal=()=>{
    setLoggedIn(true)
}
    const customStyles = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
        },
    };
    const style = {
        width: "34%",
        height: "120px",
        margin: "0 auto"
    }
    return (
        <div>
            <Modal
                isOpen={LoggedIn}
                onRequestClose={closeModal}
                style={customStyles}
                contentLabel="Example Modal"
            >
                <div className="inner-success-modal">
                    <div className="close-btn" onClick={() => closeModal()}><span>X</span></div>
                    <div className="success-image">
                        <Lottie animationData={Complete} style={style} />
                    </div>
                    <div className="modal-message" >
                       Logged Out Successfully.
                    </div>
                    <div className="ok-btn">
                        <button onClick={() => closeModal()}>OK</button>
                    </div>
                </div>

            </Modal>
        </div>
    )
}

export default LoggedOut